import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { useFetchMock } from "src/mock_data/useMockData";

import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchDetailWrapper } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import useSWRMutation from "swr/mutation";

const AddTerm: React.FC<{ page: PagesID }> = ({ page }) => {
  const { t } = useTranslation(["forums-terms-page"]);
  const navigate = useNavigate();
  const { id } = useParams();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  //TODO mock
  // const { columns } = useFetchMock(
  //   PagesID["corporate.initiative.discussion.terms.add"]
  // );

  const { columns } = useFetchDetailWrapper(
    `${ServicesURL.postWrapper}`,
    {
      body: {},
      method: `${MethodType.GET}`,
      endpoint: `${ServicesURL.getTerms}`,
      initiativeid: null,
      corporateid: +id!,
    },
    PagesID["corporate.initiative.discussion.terms.add"],
    false
  );

  const { trigger: triggerAddTerms } = useSWRMutation(
    ServicesURL.postWrapper,
    (url: string, arg: { arg: any }) =>
      fetcher<any>(`${url}`, MethodType.POST, { ...arg.arg })
  );

  const onSubmit = async (inputForm: any) => {
    let wrapperObj = {
      body: {
        name: inputForm?.name,
      },
      method: `${MethodType.POST}`,
      endpoint: `${ServicesURL.getTerms}`,
      initiativeid: null,
      corporateid: +id!,
    };
    try {
      await triggerAddTerms(wrapperObj);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
    }
  };

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-terms.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <AddEditFormCst
            actionsForForms={[]}
            columns={columns}
            onSubmit={onSubmit}
            backButton={() => {
              navigate(-1);
            }}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </>
  );
};

export default AddTerm;
